module.exports = __webpack_public_path__ + "fonts/EuclidFlex-Medium.e1c459d.otf";